<template>
    <button type="button">Click me!</button>
</template>
